"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Indicator = exports.Item = exports.Root = exports.CheckboxGroupIndicator = exports.CheckboxGroupItem = exports.CheckboxGroup = exports.createCheckboxGroupScope = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const CheckboxPrimitive = tslib_1.__importStar(require("@radix-ui/react-checkbox"));
const react_checkbox_1 = require("@radix-ui/react-checkbox");
const react_compose_refs_1 = require("@radix-ui/react-compose-refs");
const react_context_1 = require("@radix-ui/react-context");
const react_primitive_1 = require("@radix-ui/react-primitive");
const RovingFocusGroup = tslib_1.__importStar(require("@radix-ui/react-roving-focus"));
const react_roving_focus_1 = require("@radix-ui/react-roving-focus");
const react_use_controllable_state_1 = require("@radix-ui/react-use-controllable-state");
const react_direction_1 = require("@radix-ui/react-direction");
/* -------------------------------------------------------------------------------------------------
 * CheckboxGroup
 * -----------------------------------------------------------------------------------------------*/
const CHECKBOX_GROUP_NAME = 'CheckboxGroup';
const [createCheckboxGroupContext, createCheckboxGroupScope] = (0, react_context_1.createContextScope)(CHECKBOX_GROUP_NAME, [react_roving_focus_1.createRovingFocusGroupScope, react_checkbox_1.createCheckboxScope]);
exports.createCheckboxGroupScope = createCheckboxGroupScope;
const useRovingFocusGroupScope = (0, react_roving_focus_1.createRovingFocusGroupScope)();
const useCheckboxScope = (0, react_checkbox_1.createCheckboxScope)();
const [CheckboxGroupProvider, useCheckboxGroupContext] = createCheckboxGroupContext(CHECKBOX_GROUP_NAME);
const CheckboxGroup = React.forwardRef((props, forwardedRef) => {
    const { __scopeCheckboxGroup, name, defaultValue, value: valueProp, required = false, disabled = false, orientation, dir, loop = true, onValueChange, ...groupProps } = props;
    const rovingFocusGroupScope = useRovingFocusGroupScope(__scopeCheckboxGroup);
    const direction = (0, react_direction_1.useDirection)(dir);
    const [value = [], setValue] = (0, react_use_controllable_state_1.useControllableState)({
        prop: valueProp,
        defaultProp: defaultValue,
        onChange: onValueChange,
    });
    const handleItemCheck = React.useCallback((itemValue) => setValue((prevValue = []) => [...prevValue, itemValue]), [setValue]);
    const handleItemUncheck = React.useCallback((itemValue) => setValue((prevValue = []) => prevValue.filter((value) => value !== itemValue)), [setValue]);
    return (React.createElement(CheckboxGroupProvider, { scope: __scopeCheckboxGroup, name: name, required: required, disabled: disabled, value: value, onItemCheck: handleItemCheck, onItemUncheck: handleItemUncheck },
        React.createElement(RovingFocusGroup.Root, { asChild: true, ...rovingFocusGroupScope, orientation: orientation, dir: direction, loop: loop },
            React.createElement(react_primitive_1.Primitive.div, { role: "group", "data-disabled": disabled ? '' : undefined, dir: direction, ...groupProps, ref: forwardedRef }))));
});
exports.CheckboxGroup = CheckboxGroup;
CheckboxGroup.displayName = CHECKBOX_GROUP_NAME;
/* -------------------------------------------------------------------------------------------------
 * CheckboxGroupItem
 * -----------------------------------------------------------------------------------------------*/
const ITEM_NAME = 'CheckboxGroupItem';
const CheckboxGroupItem = React.forwardRef((props, forwardedRef) => {
    const { __scopeCheckboxGroup, disabled, ...itemProps } = props;
    const context = useCheckboxGroupContext(ITEM_NAME, __scopeCheckboxGroup);
    const isDisabled = context.disabled || disabled;
    const rovingFocusGroupScope = useRovingFocusGroupScope(__scopeCheckboxGroup);
    const checkboxScope = useCheckboxScope(__scopeCheckboxGroup);
    const ref = React.useRef(null);
    const composedRefs = (0, react_compose_refs_1.useComposedRefs)(forwardedRef, ref);
    const checked = context.value?.includes(itemProps.value);
    return (React.createElement(RovingFocusGroup.Item, { asChild: true, ...rovingFocusGroupScope, focusable: !isDisabled, active: checked },
        React.createElement(CheckboxPrimitive.Root, { name: context.name, disabled: isDisabled, required: context.required, checked: checked, ...checkboxScope, ...itemProps, ref: composedRefs, onCheckedChange: (checked) => {
                if (checked) {
                    context.onItemCheck(props.value);
                }
                else {
                    context.onItemUncheck(props.value);
                }
            } })));
});
exports.CheckboxGroupItem = CheckboxGroupItem;
CheckboxGroupItem.displayName = ITEM_NAME;
/* -------------------------------------------------------------------------------------------------
 * CheckboxGroupIndicator
 * -----------------------------------------------------------------------------------------------*/
const INDICATOR_NAME = 'CheckboxGroupIndicator';
const CheckboxGroupIndicator = React.forwardRef((props, forwardedRef) => {
    const { __scopeCheckboxGroup, ...indicatorProps } = props;
    const checkboxScope = useCheckboxScope(__scopeCheckboxGroup);
    return React.createElement(CheckboxPrimitive.Indicator, { ...checkboxScope, ...indicatorProps, ref: forwardedRef });
});
exports.CheckboxGroupIndicator = CheckboxGroupIndicator;
CheckboxGroupIndicator.displayName = INDICATOR_NAME;
/* ---------------------------------------------------------------------------------------------- */
const Root = CheckboxGroup;
exports.Root = Root;
const Item = CheckboxGroupItem;
exports.Item = Item;
const Indicator = CheckboxGroupIndicator;
exports.Indicator = Indicator;
//# sourceMappingURL=checkbox-group.primitive.js.map